import { QueryParamsDto } from '../dtos/query-params.dto';
import { ExportExcel } from '../models/export-excel';
import { User } from '../models/user';
import { managerRequestMapper } from './group-admin-request.mapper';

/**
 * Map model from dto.
 * @param {object} dto Dto.
 * @returns {ExportExcel}
 */
function fromDto(dto) {
  return new ExportExcel({
    name: dto.name,
    url: dto.url,
  });
}
/**
 * Map export excel data to dto.
 * @param {object} data Query params.
 * @param {QueryParamsDto} data.queryParams Query params.
 * @param {number[]} data.selectedRegistrationIds Selected registration ids.
 * @param {User} data.groupAdmin Group admin.
 * @param {User} data.learner Learner.
 * @returns {object}
 */
function toDto({
  queryParams, selectedRegistrationIds, groupAdmin, learner,
}) {
  return {
    ...queryParams,
    ...managerRequestMapper.toDto({ groupAdmin, learner }),
    ids: selectedRegistrationIds,
  };
}

export const exportExcelMapper = {
  fromDto,
  toDto,
};
